export default "__VITE_ASSET__Dh30jVUh__"